module.exports = __webpack_public_path__ + "static/media/ford-tracker.eedd485d.png";